import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FuelRadio } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import useAmplitude from '@hooks/useAmplitude';
import { optionsSelect } from './FieldRadiosConstants';

function FieldRadios() {
  const { setValue } = useFormContext();
  const { amplitudeEvent } = useAmplitude();

  return (
    <FuelFlex defaultProps={{ flexDirection: 'column', gap: 'km3' }}>
      {optionsSelect.data.map((option) => (
        <FuelRadio
          data-testid={option.text}
          onFuel-change={() => {
            setValue('reason', option.slug);
            amplitudeEvent('journey_canceled_option_click', {
              name: option.slug,
              text: option.text,
            });
          }}
          label={option.text}
          name="cancel-options"
          key={option.slug}
        />
      ))}
    </FuelFlex>
  );
}

export default FieldRadios;
